// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutUsHero_container__7iBc7","title":"aboutUsHero_title__PDaqi","hide":"aboutUsHero_hide__EhBn6"};